import { PropTypes } from 'prop-types';
import React from 'react';

import styles from './styles.module.scss';

const MONTHLY_LIMIT = 50;

function MonthlyUploads(props) {
  const { aiUploadsThisMonth, isPremium } = props;

  if (!isPremium) return null;

  return (
    <div className={ styles.Root }>
      <div className={ styles.Container }>
        <p className={ styles.Title }>AI screenshot uploads</p>

        <p className={ styles.Count }>
          { aiUploadsThisMonth } of { MONTHLY_LIMIT }
        </p>
      </div>

      <p className={ styles.SubText }>
        Upload screenshots or PDFs to automatically generate flashcards.
        Your uploads reset at the start of each month.
      </p>
    </div>
  );
}

MonthlyUploads.propTypes = {
  aiUploadsThisMonth : PropTypes.number,
  isPremium          : PropTypes.bool,
};

export default MonthlyUploads;
